import _colors from "./lib/public/colors";
var exports = {};
let colors = _colors;
exports = (colors.__esModule ? colors : {
  default: colors
}).default;
export default exports;